export const text = {
  title: 'Questionnaire Records',
  userType: 'User Type',
  question: 'Question',
  answer: 'Answer',
  date: 'Date',
};
